import { Component, OnInit } from '@angular/core';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ProductServiceService } from 'src/app/services/core/quickbook/product-services/product-service.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { Subject, debounceTime, filter } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';

@UntilDestroy()

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})

export class ProductListComponent implements OnInit {
  services: any;
  selectedCompany: any = '';
  currentPage: number = 1;
  totalPages:any = 0;
  totalResults:any = 0;
  loadingId = null;
  numberOfRecords = NUMBER_OF_RECORDS;
  serviceDetail:any;
  search: any = '';
  private searchSubject = new Subject<string>();
  selectedDropdownIndex: any;
  toggleActionButtons = false;

  constructor(
    private productService: ProductServiceService,
  ) { }

  ngOnInit() {
    this.initializeSearch();
    this.getProductServices(this.currentPage);
  }

  getProductServices(page: any) {
    let queryParams:any = {
      limit: this.numberOfRecords,
      page
    }
    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryParams.search = trimmedSearch;
    }
    this.productService.getProductServices(queryParams).subscribe({
      next: (data:any) => {
        if (data) {
          this.services = data.results;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      },
      error: (err) => {
        sweetAlert('Error', err, 'error', 'Ok');
      }
    })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getProductServices(page);
  }

  async onSyncProductService(companyId: any, serviceId:any, type: any) {
    const mPull = `Are you sure you want to overwrite service data with quickbooks data?`
    const mPush = 'Are you sure you want to overwrite the qucikbooks data with service data'
    const result = await sweetAlert('Alert', type === 'pull' ? mPull : mPush, 'warning', 'Yes', 'No');
    if (!result.value) return;

    const item = this.services?.find((s: any) => s.id === serviceId) || {};
    if (type === 'pull') item.pulling = true; else item.pushing = true;
    const queryParams = {
      isSyncFrom: type === 'pull' ? true : false
    }

    this.productService.syncProductService(companyId, serviceId, queryParams).subscribe(
      {
        next: (data: any) => {
          this.getProductServices(this.currentPage);
          sweetAlert('Success', data?.message || 'Synced successfully', 'success', 'Ok');
        },
        error: (err) => {
          console.error(err);
          sweetAlert('Error', err, 'error', 'Ok');
          item.pulling = false;
          item.pushing = false;
        },
        complete: () => {
          item.pulling = false;
          item.pushing = false;
        }
      })
  }

  opendetailModal(item: any) {
    this.serviceDetail = item;
  }


  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search: any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getProductServices(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  showActionButtons(idx: any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt: any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

}
